export const ATTENDANCE_QR_PREFIX = 'ROS-ATTENDANCE-QR1:';

const TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

export function parseAttendanceQrPayload(payload) {
  if (typeof payload !== 'string' || !payload.startsWith(ATTENDANCE_QR_PREFIX)) {
    throw new Error('QR RestaurantOS non riconosciuto.');
  }
  const token = payload.slice(ATTENDANCE_QR_PREFIX.length);
  if (!TOKEN_PATTERN.test(token)) throw new Error('QR RestaurantOS non valido.');
  return token;
}

export function createAttendanceRequestId(cryptoApi = globalThis.crypto) {
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  if (!cryptoApi?.getRandomValues) throw new Error('Generatore sicuro non disponibile.');
  const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export async function scanAttendanceQr() {
  const plugin = globalThis.window?.Capacitor?.Plugins?.RestaurantOSQrScanner;
  if (!plugin?.scanAttendanceQr) {
    throw new Error('Scanner QR disponibile nell’app iPhone aggiornata.');
  }
  const result = await plugin.scanAttendanceQr();
  return parseAttendanceQrPayload(result?.payload);
}
